import { Modal } from '@/ui/Modal.jsx';
import { iosInstallModalOpen } from '@/pwa/install';
import css from './IosInstallModal.module.css';

/**
 * Инструкция установки на iOS Safari (там нет системного beforeinstallprompt).
 * Показывает шаги: Поделиться → На экран «Домой» → Добавить.
 */
export function IosInstallModal() {
  const open = iosInstallModalOpen.value;
  return (
    <Modal
      open={open}
      title="Установка на iPhone"
      onClose={() => (iosInstallModalOpen.value = false)}
      ariaLabel="Как установить приложение на iPhone"
    >
      <div class={css.intro}>В Safari установка делается в три шага:</div>
      <ol class={css.steps}>
        <li>
          <span class={css.num}>1</span>
          <span class={css.body}>
            Нажмите кнопку <b>«Поделиться»</b>
            <span class={css.shareIcon} aria-hidden="true">
              <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 15V4" />
                <path d="M8.5 7.5 12 4l3.5 3.5" />
                <path d="M6 12v6a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6" />
              </svg>
            </span>
            внизу экрана
          </span>
        </li>
        <li>
          <span class={css.num}>2</span>
          <span class={css.body}>
            Выберите <b>«На экран &laquo;Домой&raquo;»</b>
            <span class={css.shareIcon} aria-hidden="true">
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <rect x="4" y="4" width="16" height="16" rx="3" />
                <path d="M12 8v8 M8 12h8" />
              </svg>
            </span>
          </span>
        </li>
        <li>
          <span class={css.num}>3</span>
          <span class={css.body}>
            Нажмите <b>«Добавить»</b> в правом верхнем углу
          </span>
        </li>
      </ol>
      <div class={css.note}>
        После установки иконка «Склад&nbsp;Колес» появится на экране «Домой», а приложение откроется
        в полноэкранном режиме — как нативное.
      </div>
      <button type="button" class="btn btn-primary" style={{ width: '100%' }} onClick={() => (iosInstallModalOpen.value = false)}>
        Понятно
      </button>
    </Modal>
  );
}
